import domain from '@/server-config/domain.config'

export type AfterSaleSite = 'testing' | 'uat' | 'pro'

/** 根据 SELLER_H5_URL 映射 sellerApp 的 afterSaleSite */
export const getAfterSaleSite = (
  sellerH5Url: string = domain.SELLER_H5_URL
): AfterSaleSite => {
  if (sellerH5Url.includes('kilitest.com')) {
    return 'testing'
  }
  if (sellerH5Url.includes('kiliuat.com')) {
    return 'uat'
  }
  return 'pro'
}

export const appendAfterSaleSite = (url: string, site: AfterSaleSite = getAfterSaleSite()) => {
  // afterSaleSite 必须拼接在 hash(#) 之前的真实 query 上，
  // 否则 sellerApp 内部 hash 路由跳转后该参数会从 URL 中丢失，
  // 刷新页面时 window.location.href 读不到 afterSaleSite，会被兜底为 'pro' 导致环境错误
  const hashIndex = url.indexOf('#')
  const base = hashIndex > -1 ? url.slice(0, hashIndex) : url
  const hash = hashIndex > -1 ? url.slice(hashIndex) : ''
  const separator = base.includes('?') ? '&' : '?'
  return `${base}${separator}afterSaleSite=${site}${hash}`
}
